import { 
    MessageResponseDto, 
    GetSubscriptionDto, 
    CreateSubscriptionDto, 
    EditSubscriptionDto,
    SubscriptionControllerGet200Response,
    SubscriptionApiFp,
    DeleteSubscriptionDto,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseSubscriptionModel = SubscriptionControllerGet200Response;
export type GetSubscriptionModel = GetSubscriptionDto;
export type MutateResponseSubscriptionModel = MessageResponseDto;
export type CreateSubscriptionModel = CreateSubscriptionDto;
export type UpdateSubscriptionModel = EditSubscriptionDto;
export type DeleteSubscriptionModel = DeleteSubscriptionDto;

export const apiSubscriptionFp = SubscriptionApiFp(apiConfig);
export const getSubscriptionController = apiSubscriptionFp.subscriptionControllerGet;
export const createSubscriptionController = apiSubscriptionFp.subscriptionControllerCreate;
export const updateSubscriptionController = apiSubscriptionFp.subscriptionControllerEdit;
export const deleteSubscriptionController = apiSubscriptionFp.subscriptionControllerDelete;

export const QueryKeySubscription = QueryKey.Subscription;